import { Config } from '../../config/config.es6';

export default class topBooks {
    constructor() {
        this.url = document.querySelector('.js-siteurl');
        this.siteurl = this.url.getAttribute('href');

        this.levelSection = [...document.querySelectorAll('.js-tab-contents')];
    }

    async setEachLevelList(rebuildBooksData) {
        await this.searchUrl();

        // CHANGED: 級の並びが逆になるので配列を逆順に（必須対応）
        rebuildBooksData = rebuildBooksData.reverse();

        this.levelSection.forEach((levelSection, index) => {
            const currentLevel = levelSection.getAttribute('id');

            rebuildBooksData[index].forEach((eachLevelData, i) => {
                // CHANGED:
                // また、css側で制御できるので、ここで「col3」classを付与しなくてよい
                // 参考：　https://shanabrian.com/web/html-css-js-technics/css-change-style-number-of-child-elements.php
                const steps = [...levelSection.querySelectorAll('.step')];

                steps.forEach((elm) => {
                    const step = elm.getAttribute('data-step');
                    const field = elm.querySelector('.body ul');

                    if (step === eachLevelData.step) {
                        const { contents1, contents2 } = this.generateContentsText(eachLevelData);
                        field.insertAdjacentHTML('afterbegin', `<li>${contents2}</li>`);

                        // content1ApendLevelで指定したlevelの書籍をcontents1に表示させる
                        if (!currentLevel.includes(Config.content1ApendLevel)) return;
                        const parentElm = document.querySelector(`[data-contents1-step="${step}"]`);
                        if (!parentElm) return;
                        parentElm.insertAdjacentHTML('afterbegin', `<li>${contents1}</li>`);
                    }
                });
            });

            // 書影のないStepは削除
            const my_step = [...levelSection.querySelectorAll('.step')];
            my_step.forEach((elm) => {
                const step_list = elm.querySelector('.body li');
                if (step_list === null) {
                    elm.remove();
                }
            });
        });
    }

    generateContentsText(elm) {
        const siteurl = this.siteurl;
        const obj = {
            img: `<div class="image"><img src="./assets/img/books/${elm.contents_code}.jpg" alt=""></div>`,
            title: '',
            manabi: '',
            newver: '',
            smallclass: '',
            link: '',
            marksheet: '',
            oldver: '',
        };

        // TODO: elm.manabiは値があるか／ないかの二択なので、条件を絞って行数を減らす
        if (elm.manabi) {
            obj.manabi = '<br><span class="min">（まなびライブラリー版）</span>';
        }

        if (elm.marksheet) {
            obj.marksheet = `<div class="link -sheet"><a target="_blank" href="${Config.imgDir}pdf/${elm.contents_code}_marksheet.pdf"><span>解答用紙</span></a></div>`;
        }

        obj.title = `<p>${elm.book_title}${obj.manabi}</p>`;
        obj.link = `<div class="link"><a href="${siteurl}/kyouzaikan/ShowContents?contentsCd=OBUN${elm.contents_code}"><span ${obj.smallclass}>${obj.newver}かりる</span></a></div>`;

        const result = {
            contents1: '',
            contents2: obj.img + obj.title + obj.link + obj.marksheet + obj.oldver + obj.smallclass,
        };

        if (elm.level.includes(Config.content1ApendLevel)) result.contents1 = obj.img + obj.title;

        return result;
    }

    async searchUrl() {
        // 条件を満たすまでループ
        while (this.siteurl.indexOf('https') !== 0) {
            this.siteurl = this.url.getAttribute('href');

            if (this.siteurl.indexOf('https') === 0) {
                break;
            }

            await new Promise((resolve) => setTimeout(resolve, 1000));
        }
    }
}
